import styled from 'styled-components';
import { Typography } from 'antd';

const { Title } = Typography;

export const StyledTitle = styled(Title)<{ token: any }>`
  text-align: center;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 24px;
  letter-spacing: 0.8px;
  line-height: 2 !important;
  position: relative;
  display: inline-block;
  color: ${({ token }) => token.colorPrimary} !important;
  font-size: 18px !important;
  width: -webkit-fill-available;
  padding: 0;
`;
